import * as libraryExports from './library';
import * as loadableExports from './loadable';

const { loadable } = loadableExports;
loadable.lib = libraryExports.loadable;

const { lazy } = loadableExports;
lazy.lib = libraryExports.lazy;

export default loadable;
export { lazy };

export { default as loadableReady } from './loadableReady';
